import { type ReactNode } from "react";
import { Stack, Typography } from "~/common/mui";

interface FormSectionProps {
  title?: string;
  children: ReactNode;
  className?: string;
}

export const FormSection = ({ title, children, className }: FormSectionProps) => (
  <Stack gap={2} className={className}>
    {title && (
      <Typography variant="bodyLarge" fontWeight={"bold"}>
        {title}
      </Typography>
    )}
    {children}
  </Stack>
);
